import{a as e}from"./chunk-EMIEIAAH.js";function a(...r){return e(n,r)}var n=(r,t)=>[...r].sort(t);export{a};
